import mitt from "mitt";

const _bus = mitt();

export default _bus;
